import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
});

let isRedirecting = false;

const dispatchToast = (message, severity = 'error') => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('hv-toast', {
      detail: {
        message,
        severity,
      },
    })
  );
};

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const isAuthEndpoint = requestUrl.includes('/api/v1/auth/');

    if (status === 403 && !isAuthEndpoint) {
      dispatchToast('You are not allowed to access this resource.', 'error');
      if (!isRedirecting) {
        isRedirecting = true;
        const currentPath = window.location.pathname || '/';
        const query = new URLSearchParams({
          reason: 'forbidden',
          from: currentPath,
        });
        window.location.href = `/no-auth?${query.toString()}`;
      }
    }

    if (status === 401 && !isAuthEndpoint && !isRedirecting) {
      isRedirecting = true;
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
